export interface TimeOffPolicyClass{
    AccountTimeOffPolicyId:string,
    AccountTimeOffPolicy:string,
    AccountId:number,
    MasterTimeOffPolicyId:string,
    IsDisabled:boolean,
    IsDeleted:boolean,
    detail:Array<TimeOffPolicyDetailClass>;
    isSelected:number;
}

export interface TimeOffPolicyDetailClass{
    AccountTimeOffPolicyDetailId:string,
    AccountTimeOffPolicyId : string,
    AccountTimeOffTypeId : string,
    AccountTimeOffType : string,
    SystemEarnPeriodId : string ,
    SystemResetToZeroTypeId : string ,
    InitialSetToHours : number ,
    ResetToHours : number ,
    EarnHours : number ,
    CarryOver : number ,
    MaximumAvailable : number ,
    AccountId:number,
    MasterTimeOffPolicyDetailId: string ,
    EffectiveDate : Date ,
    IsInclude : boolean ,
    AdditionalHours: number ,
    CarryForwardExpiryDate: Date ,
    IsEnabled : boolean ,
    IsTimeOffRequestRequired:boolean,
}



const common = {    
    AccountTimeOffPolicy:"",
    AccountId:0,
    MasterTimeOffPolicyId:"",
    IsDisabled:false,
    IsDeleted:false,
    detail:[]

  };

  
  export const TimeOffPoliciesInitialsForAdd = { ...common };
  
  export const TimeOffPoliciesInitialsForUpdate = {
    ...common,
    AccountTimeOffPolicyId:"",
  };





  